import { getBaseLangIso } from "@nxplatform/helpers/helpers-pure";
const LOCALE_SETUP_FEATURE_KEY = "localeSetup";
var PlatformMenuAction = /* @__PURE__ */ ((PlatformMenuAction2) => {
  PlatformMenuAction2["aviator"] = "aviator";
  PlatformMenuAction2["crash"] = "crash";
  PlatformMenuAction2["mobileAppLink"] = "mobileAppLink";
  PlatformMenuAction2["kenoLotto"] = "kenoLotto";
  PlatformMenuAction2["fastGames"] = "fast-games";
  return PlatformMenuAction2;
})(PlatformMenuAction || {});
const BaseApplicationLanguage = getBaseLangIso();
export {
  BaseApplicationLanguage,
  LOCALE_SETUP_FEATURE_KEY,
  PlatformMenuAction
};
